import { PscList } from '../components';

const PortStateControlRoute = () => {
    return <PscList />;
};

export default PortStateControlRoute;
